export default "__VITE_ASSET__C1lFdeH1__"